import { render, staticRenderFns } from "./CoupassStaffStats.vue?vue&type=template&id=22b1af57&scoped=true"
import script from "./CoupassStaffStats.vue?vue&type=script&lang=js"
export * from "./CoupassStaffStats.vue?vue&type=script&lang=js"
import style0 from "./CoupassStaffStats.vue?vue&type=style&index=0&id=22b1af57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1af57",
  null
  
)

export default component.exports